var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66003 26.7368C2.66003 24.9786 3.13215 23.2508 4.02975 21.7242C4.92735 20.1975 6.21936 18.9248 7.77812 18.0319C9.33689 17.1389 11.1085 16.6566 12.9178 16.6325C14.7271 16.6085 16.5116 17.0435 18.0949 17.8947M22.16 21.6842L28.66 28M28.66 21.6842L22.16 28M19.56 10.3158C19.56 13.8039 16.6499 16.6316 13.06 16.6316C9.47018 16.6316 6.56003 13.8039 6.56003 10.3158C6.56003 6.82768 9.47018 4 13.06 4C16.6499 4 19.56 6.82768 19.56 10.3158Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserX);
export default __webpack_public_path__ + "static/media/user-x.25b26ec3ef02c1767baec6929cc4872b.svg";
export { ForwardRef as ReactComponent };